app.controller("AddContainer", ["$scope", "StaticData", "ProgramService", "$uibModalInstance", "params",
    function ($scope, StaticData, ProgramService, $uibModalInstance, params) {
        $scope.container = {
            name: "",
            type: params.type,
            parent: null,
            program: params.programId,
            required: 0
        };

        StaticData.getItemsByKey("container_types").then(function (types) {
            $scope.types = types;
        });

        $scope.create = function () {
            ProgramService.createContainer($scope.container).then(function () {
                $uibModalInstance.close();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);